import { all } from 'redux-saga/effects';
import reportsInvoicesSaga from 'sagas/reports/invoices';
import reportsSalesSaga from 'sagas/reports/sales';
import reportsShiftsSaga from 'sagas/reports/shifts';
import reportsTransactionsSaga from 'sagas/reports/transactions';

export default function* reportsSaga() {
  yield all([
    reportsInvoicesSaga(),
    reportsSalesSaga(),
    reportsShiftsSaga(),
    reportsTransactionsSaga(),
  ]);
}
